import { DefaultLoader } from '@/components/loaders';
import { CustomerSelectors } from '@/store/customer';
import { FormsActions } from '@/store/forms';
import { MatchedGrantsActions, MatchedGrantsSelectors } from '@/store/matchedGrants';
import { MatchedPFActions } from '@/store/matchedPF';
import { MatchedPFSelectors } from '@/store/matchedPF/matchedPF.selector';
import { PotentialFundingGraph } from '@/views/salesWizard/subComponents/steps/GrantSearch/PotentialFundingGraph';
import { Box, Button, Grid2, Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmptySearchResult } from './EmptySearchResult';
import { GrantsMetricsCards } from './GrantMetricsCards';
import { GrantMetricsGraph } from './GrantMetricsGraph';
export const GrantsSearch = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const grantsLoading = useSelector(MatchedGrantsSelectors.getLoading);
    const { _id: customerId = '' } = useSelector(CustomerSelectors.makeCustomer);
    const { totalGrants } = useSelector(MatchedGrantsSelectors.makeCustomerGrantsMetrics);
    const { totalPFs } = useSelector(MatchedPFSelectors.makeMatchedPFMetrics);
    const totalCount = totalPFs + totalGrants;
    useEffect(() => {
        if (customerId) {
            dispatch(MatchedGrantsActions.fetchCustomerMatchedGrantsAsync({ customerId }));
            dispatch(MatchedPFActions.fetchCustomerMatchedPFAsync({
                customerId,
                options: { params: { $paging: false } },
            }));
        }
    }, [customerId]);
    return (React.createElement(React.Fragment, null,
        grantsLoading && React.createElement(DefaultLoader, { loaderProps: { sx: { mt: 20 } } }),
        !grantsLoading && !totalGrants && React.createElement(EmptySearchResult, null),
        !grantsLoading && !!totalGrants && (React.createElement(Box, { my: 4, px: 2, width: "100%", maxWidth: "880px" },
            React.createElement(Stack, null,
                React.createElement(Typography, { color: "secondary", fontSize: "1rem", fontWeight: 600 }, "Great news!"),
                React.createElement(Typography, { color: "secondary", fontSize: "1rem", fontWeight: 600 }, `We found ${totalCount} opportunities! You can see the breakdown below`)),
            React.createElement(GrantsMetricsCards, null),
            React.createElement(Grid2, { container: true, flexDirection: "row", columns: 12, justifyContent: "flex-start" },
                React.createElement(Grid2, { container: true, size: { xs: 12, md: 6 }, sx: {
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    } },
                    React.createElement(GrantMetricsGraph, null)),
                React.createElement(Grid2, { container: true, size: { xs: 12, md: 6 }, sx: {
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    } },
                    React.createElement(PotentialFundingGraph, null))),
            React.createElement(Box, { sx: { p: 2, border: `1px solid ${theme.palette.grey[200]}`, borderRadius: '16px' } },
                React.createElement(Typography, { color: "secondary", fontSize: "1rem", fontWeight: 600 }, "Want to see the full list of specific grants?"),
                React.createElement(Stack, { mt: 1.5, direction: "row", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Button, { variant: "outlined", disableElevation: true, sx: {
                            height: '50px',
                            background: 'white',
                            borderRadius: '8px',
                            letterSpacing: '0.2px',
                            textTransform: 'none',
                            color: 'secondary.main',
                            borderColor: theme.palette.grey[300],
                            fontSize: { xs: '0.857rem', sm: '1rem' },
                        }, onClick: () => dispatch(FormsActions.setValue({ id: 'steps', step: 1 })) }, "Go back"),
                    React.createElement(Button, { type: "submit", disableElevation: true, variant: "contained", onClick: () => dispatch(FormsActions.setValue({ id: 'steps', step: 3 })), sx: {
                            width: '180px',
                            height: '50px',
                            fontWeight: 500,
                            borderRadius: '8px',
                            textTransform: 'none',
                            letterSpacing: '0.2px',
                            fontSize: { xs: '0.857rem', sm: '1rem' },
                        } }, "View grants list")))))));
};
